import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Carousel from 'components/Carousel';
import CarouseLinkItem from 'components/Carousel/components/CarouseLinkItem';
import React, { useState } from 'react';

import BannerBidingEvent from 'assets/images/banner/bidding-event.jpg';
import BannerBidingEVentMobile from 'assets/images/banner/bidding-event-mobile.jpg';
import BannerCollectible from 'assets/images/banner/collectible.jpg';
import BannerCollectibleMobile from 'assets/images/banner/collectible-mobile.jpg';

import { StyledAnimatedCard } from 'components/Card/Card';
import LazySection from 'components/LazySection';
import { MODULES } from 'config/constants/modules';
import { useEventListener } from 'hooks/useEventListener';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSpring } from 'react-spring';
import styled from 'styled-components';
import NFTCollection from './components/NFTCollection';


import BannerCardMarketPlace from 'assets/images/banner/card-home-marketplace.png';
import BannerCardMySterybox from 'assets/images/banner/card-home-mysterybox.png';

const carouselSlides = [
	{
		key: 1,
		content: <CarouseLinkItem img={BannerBidingEvent} imgMobile={BannerBidingEVentMobile} target="_self" />,
	},
	{
		key: 2,
		content: (
			<CarouseLinkItem img={BannerCollectible} imgMobile={BannerCollectibleMobile} target="_self" />
		),
	},
];

const Home: React.FC = () => {
	const [isSmall, setIsSmall] = useState(window?.screen.width <= 769);

	useEventListener({
		type: 'resize',
		listener: (event) => {
			if ((event.currentTarget as Window).screen.width <= 768) {
				if (!isSmall) setIsSmall(true);
			} else {
				if (isSmall) setIsSmall(false);
			}
		},
	});

	return (
		<StyledWrapper>
			<LazySection>
				<Carousel slides={carouselSlides} />
			</LazySection>

			<StyledPageContent>
				<LazySection disabled={isSmall}>
					<StyledPageTitle>
						<Trans>Hunny Marketplace</Trans>
					</StyledPageTitle>
					<StyledPageSubTitle>
						<Trans>A market made for NFT, where everything is special</Trans>
					</StyledPageSubTitle>
				</LazySection>

				<LazySection>
					<StyledCardContainer>
						<AnimatedCard>
							<StyledCardImageSection>
								<StyledCardImagWrapper>
									<img src={BannerCardMarketPlace} />
								</StyledCardImagWrapper>
							</StyledCardImageSection>
							<StyledCardContentSection>
								<div className="title">
									<Trans>Marketplace</Trans>
								</div>
								<div className="content">
									<Trans>
										Discover, collect, and sell extraordinary NFTs on Hunny NFT Marketplace. We will
										brings artists, brands, influencers, whales, and industry experts use the
										platform to showcase and trade their NFTs.
									</Trans>
								</div>
								<Link className="link" to={MODULES.MARKETPLACE}>
									<Trans>Visit Now</Trans> <ChevronRightIcon />
								</Link>
							</StyledCardContentSection>
						</AnimatedCard>

						<StyledSpacer />

						<AnimatedCard>
							<StyledCardImageSection>
								<StyledCardImagWrapper>
									<img className="inside" src={BannerCardMySterybox} />
								</StyledCardImagWrapper>
							</StyledCardImageSection>
							<StyledCardContentSection>
								<div className="title">
									<Trans>Mystery Boxes</Trans>
								</div>
								<div className="content">
									<Trans>
										Mystery Box is just like Gashapon or capsule toy vending machines, collectors
										can stand a chance to get rare digital collectibles. The fun part is they won't
										know which item they will receive, digital NFTs will be randomly distributed
										throughout Mystery box event.
									</Trans>
								</div>
								<Link className="link" to={MODULES.MYSTERY_BOXES}>
									<Trans>Check Now</Trans> <ChevronRightIcon />
								</Link>
							</StyledCardContentSection>
						</AnimatedCard>
					</StyledCardContainer>
				</LazySection>

				<LazySection>
					<NFTCollection />
				</LazySection>
			</StyledPageContent>
		</StyledWrapper>
	);
};

const AnimatedCard = ({ children }) => {
	const styleOpen = useSpring({
		from: { scale: 0, opacity: 0 },
		to: { scale: 1, opacity: 1 },
		config: { tension: 200, friction: 22 },
	});

	return <StyledCard style={{ ...styleOpen }}>{children}</StyledCard>;
};

const StyledCardImagWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const StyledWrapper = styled.div`
	padding-bottom: 112px;
	min-height: calc(100vh - 80px);
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;

	width: 100%;
	box-sizing: border-box;
`;

const StyledCard = styled(StyledAnimatedCard)`
	flex: 1;
	display: flex;
	flex-direction: row;

	@media (max-width: 420px) {
		position: relative;
	}

	@media (max-width: 580px) {
		padding: 7.5px 5px;
	}
	@media (max-width: 420px) {
		padding: 20px;
	}
`;

const StyledCardImageSection = styled.div`
	flex: 1;
	min-width: 39%;
	max-width: 39%;
	position: relative;

	@media (min-width: 1200px) and (max-width: 1350px) {
		min-width: 42%;
		max-width: 42%;
	}

	@media (max-width: 420px) {
		position: absolute;
		top: 0;
		left: 50%;
		right: 0;
		bottom: 0;
		opacity: 0.3;
		z-index: 1;
		transform: translateX(-50%);
	}

	img {
		width: 85%;
		margin-top: 2.5%;
		height: auto;
		max-height: 100%;
		object-fit: fill;
		object-position: center;

		@media (min-width: 650px) and (max-width: 950px) {
			max-width: 170px;
		}
		@media (max-width: 580px) {
			width: 100%;
			max-width: 120px;
		}

		&.inside {
			@media (min-width: 650px) and (max-width: 950px) {
				max-width: 220px;
			}
			@media (min-width: 530px) and (max-width: 580px) {
				max-width: 150px;
			}
		}
	}
`;
const StyledCardContentSection = styled.div`
	flex: 2;
	padding: 48px 24px;
	padding-left: 0px;
	box-sizing: border-box;

	.title {
		font-weight: bold;
		font-size: 16px;
		line-height: 18px;
		color: #fff;

		@media (max-width: 580px) {
			font-size: calc(0.65rem + 1vw);
		}
	}

	.content {
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 20px;
		color: ${(props) => props.theme.color.grey[600]};
		margin: 12px 0px;

		@media (max-width: 580px) {
			margin: 5px 0;
			font-size: calc(0.5rem + 1vw);
		}
	}

	.link {
		text-decoration: none;

		color: ${(props) => props.theme.color.yellow[100]};
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 18px;
		display: flex;
		align-items: center;

		:hover {
			text-decoration: underline;
		}

		@media (max-width: 580px) {
			margin: 5px 0;
			font-size: calc(0.5rem + 1vw);
		}
	}

	@media (max-width: 580px) {
		padding: 0;
		position: relative;
		z-index: 1;
	}
`;

const StyledSpacer = styled.div`
	width: 24px;
	height: 24px;
`;

const StyledCardContainer = styled.div`
	width: 100%;
	display: flex;
	margin-top: 48px;
	margin-bottom: 64px;

	@media (max-width: 925px) {
		flex-direction: column;
		padding: 0 8px;
		box-sizing: border-box;
	}
`;

const StyledPageContent = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	max-width: ${(props) => props.theme.siteWidth};
	margin: 0 auto;

	padding: 0px 12px;
	box-sizing: border-box;
`;

const StyledPageTitle = styled.div`
	margin-top: 112px;

	font-style: normal;
	font-weight: bold;
	font-size: 64px;
	line-height: 74px;

	text-align: center;
	letter-spacing: -0.02em;

	color: ${(props) => props.theme.color.purple[100]};

	@media (max-width: 580px) {
		margin-top: 0px;
		font-size: calc(1.25rem + 1vw);
	}
`;

const StyledPageSubTitle = styled.div`
	margin-top: 8px;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 20px;

	text-align: center;
	letter-spacing: -0.02em;

	color: ${(props) => props.theme.color.yellow[100]};

	@media (max-width: 580px) {
		font-size: calc(0.6rem + 1vw);
	}
`;

export default Home;
